/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { FlagOperation } from "../../flags/types/FlagOperation";
import { FlagMutationConfigData } from "./FlagMutationConfigData";
export const FlagMutationConfig = core.serialization.object({
    type: core.serialization.stringLiteral("flag"),
    operation: FlagOperation,
    flag: FlagMutationConfigData,
    flags: core.serialization.list(core.serialization.string()).optional(),
});
